/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Zones_Tab_PaceInputs */

const en_ui_zones_tab_pace = /** @type {(inputs: Ui_Zones_Tab_PaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pace`)
};

const de_ui_zones_tab_pace = /** @type {(inputs: Ui_Zones_Tab_PaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempo`)
};

/**
* | output |
* | --- |
* | "Pace" |
*
* @param {Ui_Zones_Tab_PaceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_zones_tab_pace = /** @type {((inputs?: Ui_Zones_Tab_PaceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Zones_Tab_PaceInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_zones_tab_pace(inputs)
	return de_ui_zones_tab_pace(inputs)
});